import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { deleteSlot } from "../../services/slots/slots";
import Circular from "../Circular/Circular";

const useStyles = (theme) => ({
  dialog: {
    "& .MuiPaper-root": {
      margin: theme.spacing(1),
      minHeight: '12rem',
    },
  },
});

class DeleteSlot extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      spinner: false,
    };
  }

  handleClickDelete = () => {
    this.setState({ spinner: true }, () => {
      deleteSlot(this.props.lockerId, this.props.slot.id, (data) => {
        data
          ? this.props.setNotification("Porta foi deletada!", "success")
          : this.props.setNotification("Falha ao deletar Porta!", "danger");
  
        this.props.onChange(false);
      });
    })
    
  };

  handleClose = () => {
    this.props.onChange(false);
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Dialog
          className={classes.dialog}
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirmação de exclusão de Porta"}
          </DialogTitle>
          {this.state.spinner ? <Circular /> : <div>
            <DialogContent>
              <div>
                <p>Deseja realmente excluir a Porta?</p>
              </div>
            </DialogContent>
            <DialogActions>
              <div>
                <Button onClick={this.handleClose} color="default">
                  Cancelar
                </Button>
                <Button
                  onClick={this.handleClickDelete}
                  color="primary"
                  autoFocus
                >
                  Excluir
                </Button>
              </div>
            </DialogActions>
          </div>}
        </Dialog>
      </div>
    );
  }
}
export default withStyles(useStyles)(DeleteSlot);
